import React, {useCallback, useContext, useEffect, useState} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import BodyContentView from '../../views/bodyContentView';
import MATrim20TN from './ma-trim20TN';

function MATrimFinished({onExit, initiallyDisableKeypress}) {
  const [isKeypressDisabled, setIsKeypressDisabled] = useState(initiallyDisableKeypress);
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onComponent, selected} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onLeft = useCallback(() => {
    onComponent(<MATrim20TN />);
  }, []);

  useEffect(() => {
    if (!leftPress || isKeypressDisabled) return;
    onLeft();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress || isKeypressDisabled) return;
    onExit();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft, onRight: onExit});
  }, [onExit, onLeft]);

  useEffect(() => {
    if (!initiallyDisableKeypress) return;

    setTimeout(() => {
      setIsKeypressDisabled(false);
    }, 500);
  }, []);

  return (
    <BodyContentView
      title="20.0 mA Trim"
      left="Back"
      right="Finished"
      caption="If the observed output is not 20.0 mA, press &lt to re-enter the output. Otherwise, the mA input trim is complete."
    />
  );
}

export default MATrimFinished;
